import { PASSWORD_STRENGTH_REGEX } from 'global/appConstants';
import yup from 'utils/yup';

export const initialChangePasswordFormData = {
  old_password: '',
  new_password: '',
  confirm_password: '',
  showPasswordOld: false,
  showPasswordNew: false,
  showPasswordConfirm: false,
};

export const changePasswordFormValidationSchema = yup.object().shape({
  old_password: yup.string().required(),
  new_password: yup
    .string()
    .required()
    .matches(PASSWORD_STRENGTH_REGEX, () => ({
      msg: 'common:passwordStrengthMessage',
    })),
  confirm_password: yup
    .string()
    .oneOf([yup.ref('new_password'), null], { msg: 'common:passwordMustMatch' })
    .required(),
});
